import React from 'react'
import './item.css'

class ItemType extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="item-type">
                <img className="item-arrow" src={require("../assert/arrow_white.png")}></img>
                <p className="item-type-word">{this.props.name}</p>
            </div>
        );
    }
}

export default ItemType;